import {CurrenciesSelectWithContainer} from "components/currencies/select"
import {PlanResourcePeriodPrice} from "models"
import {PlanResourcePeriodsSelectWithContainer} from "components/plan-resource-periods/select"
import React from "react"

export default {
  edit: {
    attributes: [
      {
        attribute: "planResourcePeriodId",
        content: ({inputProps}) => (
          <PlanResourcePeriodsSelectWithContainer
            label={PlanResourcePeriodPrice.humanAttributeName("planResourcePeriod")}
            {...inputProps}
          />
        )
      },
      {attribute: "priceCents"},
      {
        attribute: "priceCurrency",
        content: ({inputProps}) => (
          <CurrenciesSelectWithContainer
            valueCallback={({currency}) => currency.currencyCode()}
            {...inputProps}
          />
        )
      }
    ]
  }
}
